import { z } from "zod";
import { BaseEvent } from "./base";
export const SmokeTest_Start = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.SmokeTest_Start"),
    event: z.object({
        test_id: z.string(),
        test_name: z.string(),
        test_sha: z.string()
    })
});
export const SmokeTest_Heartbeat = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.SmokeTest_Heartbeat"),
    event: z.object({
        test_id: z.string(),
        test_name: z.string(),
        test_sha: z.string()
    })
});
export const SmokeTest_Complete = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.SmokeTest_Complete"),
    event: z.object({
        test_id: z.string(),
        test_name: z.string(),
        test_sha: z.string()
    })
});
export const SmokeTest_Fail = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.SmokeTest_Fail"),
    event: z.object({
        test_id: z.string(),
        test_name: z.string(),
        test_sha: z.string(),
        error: z.string()
    })
});
